export default "__VITE_ASSET__BDV5itMF__"